import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Logo } from '@/components/generals/logo'

interface SiteHeaderProps {
    signedIn: boolean
    showSections?: boolean
}

const SECTIONS = [
    { href: '/#features', label: 'Features' },
    { href: '/#dual-mode', label: 'Phone + computer' },
    { href: '/#how-it-works', label: 'How it works' },
    { href: '/#faq', label: 'Questions' }
]

export const SiteHeader: FC<SiteHeaderProps> = ({ signedIn, showSections = true }): ReactNode => (
    <header className='sticky top-0 z-40 border-b border-transparent bg-background/80 backdrop-blur supports-backdrop-filter:bg-background/65'>
        <div className='mx-auto flex h-16 max-w-6xl items-center gap-4 px-4 sm:px-6'>
            <Link href='/' className='rounded-lg focus-visible:ring-3 focus-visible:ring-ring/50' aria-label='Chalkline home'>
                <Logo />
            </Link>

            {showSections && (
                <nav aria-label='Sections' className='ml-6 hidden items-center gap-1 lg:flex'>
                    {SECTIONS.map(item => (
                        <Link key={item.href} href={item.href} className='rounded-lg px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground'>
                            {item.label}
                        </Link>
                    ))}
                </nav>
            )}

            <div className='ml-auto flex items-center gap-2'>
                {signedIn
                    ? (
                        <Button render={<Link href='/dashboard' />} nativeButton={false}>
                            Go to dashboard
                            <ArrowRight />
                        </Button>
                    )
                    : (
                        <>
                            <Button variant='ghost' render={<Link href='/login' />} nativeButton={false}>
                                Sign in
                            </Button>

                            <Button render={<Link href='/login?mode=signup&role=educator' />} nativeButton={false} className='hidden sm:inline-flex'>
                                Start teaching
                            </Button>
                        </>
                    )}
            </div>
        </div>
    </header>
)
